module.exports = __webpack_public_path__ + "img/linkedin.44872804.svg";